import { Container, Nav, NavDropdown, Navbar} from "react-bootstrap";
import './min.css';
import logoPhoto from './maverick (4).png000.png';
import { Link } from "react-router-dom";
// import { useState } from "react";
function Navs(){
  // const [darkMood , setDarkMood] = useState(true);
  // function dark(){
  //   let darkBtn = document.querySelector('.fa-sun');
  //   let body = document.querySelector('body');
  //   let navBack = document.querySelector('#navs');
  //   let footer = document.querySelector('footer');
  //   // let h2 = document.querySelector('h2');
  //   let h3 = document.querySelectorAll('h3');
  //   setDarkMood(!darkMood);
  //   console.log(h3);
  //   if(darkMood !== true){
  //     darkBtn.style.color = 'black';
  //     // h2.style.color = 'white';
  //     body.style.backgroundColor = 'white';
  //     navBack.style.backgroundColor = 'rgb(0 0 0 / 0%)';
  //     footer.style.backgroundColor = 'rgb(0 0 0 / 72%)'
  //   }else{
  //     darkBtn.style.color = 'white';
  //     body.style.backgroundColor = 'black';
  //     // h2.style.color = 'black';
  //     navBack.style.backgroundColor = 'black';
  //   }
  // }
    return(
        <>
<Navbar id="navs" collapseOnSelect fixed="top" expand="lg" variant="dark">
      <Container>
        <Link to="/" style={{textDecoration:'none',display:'flex',alignItems:'center'}}>
          <img style={{width:'40px'}} src={logoPhoto} alt=""></img>
          <strong style={{color:'white',margin:'0', padding:'0 5px'}}>  MAVERICK
            <p style={{margin:'0 10px', padding:'0',fontSize:'8px',fontWeight:'600'}}>For Real Estate</p>
          </strong>
        </Link>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Link className="nav-link" to="/">Home</Link>
            <NavDropdown title="Find a Home" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">North Coast</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Ain Sokhna
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">6 October</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.4">New Cairo</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.5"> New Capital </NavDropdown.Item>
              {/* <NavDropdown.Divider /> */}
            </NavDropdown>
            <Link className="nav-link" to="Developers">Developers</Link>
            {/* <Link className="nav-link" to="about">About</Link> */}
            <Nav.Link href="#contact">Contact Us</Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link href="https://bit.ly/3pvjCS2">Request a Call ... <i className="fa-solid fa-phone"></i></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
          {/* <div className="dark-mood">
            <i  className="fa-solid fa-sun"></i>
          </div> */}
    </Navbar>
        </>
    )
}
export default Navs;